import styled from 'styled-components';

export const Wrapper = styled.div`
  & > div > div {
    width: auto;
    max-width: 860px;
    border-radius: 16px;
  }
`;

export const ContinueButton = styled.button`
  cursor: 'pointer';
  display: flex;
  cursor: pointer;
  border: none;
  outline: none;
  background: none;
  margin-right: 0;
  margin-left: auto;

  & > span {
    font-size: 20px;
    ${({ theme }) => theme.palette.primary.text};
  }
`;
